// extracted by mini-css-extract-plugin
module.exports = {"tc":"TableCol_tc__16nhU"};